import './Tab.124d3f37079396e4203f9f4197a2a2f8.css';
export default {"tabList":"_tabList_12wog_1","scrollable":"_scrollable_12wog_1","item":"_item_12wog_1","active":"_active_12wog_1","hidden":"_hidden_12wog_1"};